import type { WithRequired } from '@openx/types/helpers';
import type { OptionStateMap } from '@openx/types/options';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';

export function useDspsFetch(): WithRequired<OptionStateMap, 'refetch'> {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.deal_participants.demand_partner',
    },
  });

  const list = useMemo(() => {
    if (!optionsByPath) {
      return [];
    }

    return optionsByPath
      .filter(option => option != null)
      .map(option => ({
        id: option.id,
        name: option.name,
        ...option.extra,
      }));
  }, [optionsByPath]);

  const mapById = useMemo(() => {
    const map = {};
    list.forEach(option => {
      map[option.id] = option;
    });
    return map;
  }, [list]);

  return {
    loading,
    mapById,
    refetch,
  };
}
